export default __webpack_public_path__ + "static/media/fastingworkout@2x.16a435c7.jpg";